<template>
  <router-link :to="'mensajes/' + link" class="card-message d-flex align-items-center justify-content-between">
    <div>
      <img src="@/assets/profile/user_empty.png" alt="" height="20" width="20"
           class="float-left rounded-circle shadow-sm">
      <div class="username float-left ml-3">
        <p>{{from.name}} {{from.lname ? from.lname : ''}} - <b>{{ message.title }}</b>
          <br>
          <span class="text-muted">{{message.created_at}}</span></p>
      </div>
      <br>
      <div class="message-time ml-5"></div>
    </div>
    <div>
      <i class="fas fa-chevron-right"></i>
    </div>

  </router-link>
</template>
<style lang="scss">
  .card-message {
    text-decoration: none;
    color: #000;
    cursor: pointer;
    padding: 0.7em;
    border-bottom: 1px solid #EEE;

    &:hover {
      background-color: #EEE
    }
  }

  .message-time {
    font-size: 14px;
    color: #999;
  }

  .username {
    font-size: 17px;
  }
</style>
<script>
  export default {
    props: {
      link: String,
      from: Object,
      message: Object
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/#pages/messages/components/ConversationItem.vue